import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Stadium from 'stadium/Stadium';
import { getConfigForEnv } from 'shared/ConfigUtils';
import ClientLoader from './ClientLoader';
import AuthorLoader from './AuthorLoader';
import expConfig from './app.config.json';
import { jsx as _jsx } from "react/jsx-runtime";
var generateAppConfig = function generateAppConfig(config) {
  var urlSearchParams = new URLSearchParams(window.location.search);
  var currentPage = new URL(window.location.href);
  var isVisualizer = !!urlSearchParams.get('mode');
  // TODO: Handle this outside of visualizer (with user locale)
  var isRtl = urlSearchParams.get('locale') === 'iw_IL';
  var isAuthor = !!urlSearchParams.get('path');
  var replaceHost = function replaceHost(host) {
    return isAuthor ? host === null || host === void 0 ? void 0 : host.replace('publish', 'author') : host;
  };
  return {
    dataHost: replaceHost(config.urls.dataHost),
    mediaHost: replaceHost(config.urls.mediaHost),
    linkHost: replaceHost(config.urls.linkHost),
    isAuthor: isAuthor,
    isVisualizer: isVisualizer,
    isRtl: isRtl,
    urlSearchParams: urlSearchParams,
    currentPage: currentPage
  };
};
var App = function App(_ref) {
  var _ref$useNav = _ref.useNav,
    useNav = _ref$useNav === void 0 ? true : _ref$useNav;
  var config = window.location.hostname === 'localhost.nike.net' ? expConfig.local : getConfigForEnv(expConfig);
  var appConfig = generateAppConfig(config);
  var isAuthor = appConfig.isAuthor;
  config.opts || (config.opts = {});
  if (useNav) {
    config.opts.useNav = !isAuthor;
  } else {
    config.opts.useNav = useNav;
  }
  return /*#__PURE__*/_jsx("div", {
    style: _objectSpread(_objectSpread({}, appConfig.isRtl && {
      direction: 'rtl'
    }), appConfig.isVisualizer && {
      paddingBottom: 0
    }),
    children: /*#__PURE__*/_jsx(Stadium, _objectSpread(_objectSpread({}, config), {}, {
      children: isAuthor ? /*#__PURE__*/_jsx(AuthorLoader, _objectSpread({}, appConfig)) : /*#__PURE__*/_jsx(ClientLoader, _objectSpread({}, appConfig))
    }))
  });
};
export default App;